import React, { useEffect, useState } from "react"

import Button from "@/components/core/Button/Button"
import Modal from "@/components/core/Modal/Modal"

import AddressForm from "@/components/AccountSettings/v1/AddressForm"
import AddressTile from "@/components/AccountSettings/v1/Addresses/AddressTile"
import addressesStyle from "@/components/AccountSettings/v1/Addresses/index.module.scss"
import { addAnalyticsForAddAddresses } from "@/components/AccountSettings/v1/Addresses/analytics"
import PropTypes from "prop-types"

import { useDispatch, useSelector } from "react-redux"
import {
  selectGenericState,
  getCheckoutErrorList,
} from "@/store/features/genericSlice"

const Addresses = ({
  i18n = {},
  data = {},
  onAddAddress = () => {},
  onEditAddress = () => {},
  onDeleteAddress = () => {},
  country = "",
  stateData = [],
  countries = [],
  ...props
}) => {
  const [showAdd, setShowAdd] = useState(false)

  const { checkoutErrorsPath = "", checkoutErrorList: genericMessages = [] } =
    useSelector(selectGenericState)
  const dispatch = useDispatch()

  const onCloseRef = {}
  const closeForm = () => {
    setShowAdd(false)
    onCloseRef.clearDataOnClose()
  }
  const handleAddAddress = () => {
    setTimeout(() => {
      setShowAdd(true)
    }, 0)
    window.preActiveElement = document.getElementById("kf-address-tiles-0")
    addAnalyticsForAddAddresses("add address")
  }

  const handleSubmitAddAddress = (data, abbr) => {
    const addressArry = []
    setShowAdd(false)
    abbr.forEach(addressData => {
      const obj = {
        action: "addAddress",
        address: {
          city: addressData?.city?.value,
          country: country,
          custom: {
            fields: { label: addressData?.addresstypes?.value },
            type: {
              typeId: "type",
              key: "custom-address",
            },
          },
          email: data?.email,
          firstName: addressData?.firstName?.value,
          lastName: addressData?.lastName?.value,
          phone: addressData?.phone?.value,
          postalCode: addressData?.zipcode?.value,
          state: addressData?.state?.value,
          streetName: addressData?.address1?.value,
          streetNumber: addressData?.address2?.value,
          setPrimary: addressData?.label?.show,
        },
      }

      addressArry.push(obj)
    })
    onAddAddress(addressArry)
    onCloseRef.clearDataOnClose()
  }

  useEffect(() => {
    try {
      if (checkoutErrorsPath) {
        dispatch(getCheckoutErrorList())
      }
    } catch (error) {
      // error handling
    }
  }, [checkoutErrorsPath])

  return (
    <React.Fragment>
      <div className={`${addressesStyle?.addressesWrapper}`}>
        <div className={`account-address`}>
          <div className="account-settings__section-header">
            <h2 className="account-settings__section-title">
              {i18n?.addresses}
            </h2>
            <Button
              id="kf-add-address-btn"
              type="ghost"
              size="small"
              label={i18n?.addAddress}
              onClick={() => handleAddAddress()}
              role="button"
            />
          </div>
          <Modal
            showModal={showAdd}
            onModalClose={closeForm}
            modalTitle={i18n?.addAddress}
          >
            <div
              className="account-address__modal"
              aria-labelledby="add-address-title"
              aria-modal="true"
            >
              <div className="add-address__title" id="add-address-title">
                <span>{i18n?.addAddress}</span>
              </div>
              {showAdd && (
                <AddressForm
                  i18n={i18n}
                  data={{}}
                  stateData={stateData}
                  country={country}
                  countries={countries}
                  onAdd={abbr => handleSubmitAddAddress(data, abbr)}
                  onCloseRef={onCloseRef}
                  genericMessages={genericMessages}
                  {...props}
                />
              )}
            </div>
          </Modal>
          <div className="account-address__tiles" role="list">
            {data?.addresses?.map((addr, i) => (
              <AddressTile
                key={addr?.id}
                id={`kf-address-tiles-${i}`}
                i18n={i18n}
                data={addr}
                stateData={stateData}
                country={country}
                countries={countries}
                onEdit={onEditAddress}
                onDelete={onDeleteAddress}
                isDefault={data?.defaultShippingAddressId === addr?.id}
                onCloseRef={onCloseRef}
                genericMessages={genericMessages}
                {...props}
              />
            ))}
          </div>
          <div className="account-address__cta--mobile">
            <Button
              type="ghost"
              size="small"
              flexible
              label={i18n?.addAddress}
              onClick={() => handleAddAddress()}
              role="button"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
Addresses.propTypes = {
  i18n: PropTypes.object,
  data: PropTypes.object,
  onAddAddress: PropTypes.func,
  onEditAddress: PropTypes.func,
  onDeleteAddress: PropTypes.func,
  country: PropTypes.string,
  stateData: PropTypes.array,
  countries: PropTypes.array,
}

export default Addresses
